import request from "@/utils/request";

//获取设备告警列表1
export const getDeviceErrorCurrent = params => {
	return request({
		url: "/device/error/current",
		method: "GET",
		params,
	});
};
//获取设备告警数量
export const getDeviceErrorCurrentCount = params => {
	return request({
		url: "/device/error/current/count",
		method: "GET",
		params,
	});
};
//获取设备告警列表2
export const getDeviceErrorLog = params => {
	return request({
		url: "/device/error/log",
		method: "GET",
		params,
	});
};
